import styles from "./Footer.module.css";

function Footer() {
	return (
		<div className={styles.footer}>
			<div className={styles.footer_items_holder}>
				<div className={styles.footer_item}>
					<img src="/assets/icons/email.png" alt="UNHCR Logo" />
					<p>contact.turan@unhcr.org</p>
				</div>
				<div className={styles.footer_item}>
					<img src="/assets/icons/phone.png" alt="UNHCR Logo" />
					<p>0325 351 2300</p>
				</div>
			</div>
		</div>
	);
}

export default Footer;
